/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_DescInputs */

const vi_sales_return_desc = /** @type {(inputs: Sales_Return_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập số khách trả của từng dòng. Hàng về kho theo lô, giá trị trả giảm công nợ của đơn. Trả một phần thì đơn vẫn Đã giao; trả hết thì đơn chuyển Đã hoàn.`)
};

/**

* @param {Sales_Return_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_desc = /** @type {((inputs?: Sales_Return_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_desc(inputs)
});